export default class DeadAnimalInfo {
    constructor(deadAnimalFound, numberOfDeadAnimals, deadanimalinfopages) {
        this.deadAnimalFound = deadAnimalFound;
        this.numberOfDeadAnimals = numberOfDeadAnimals;
        this.deadanimalinfopages = deadanimalinfopages;
    }
}